// 加解密数据
const JSSM4 = require('jssm4')
const { sm2 } = require('sm-crypto')

const cipherMode = 1

// sm4加密
function sm4Encrypt(text) {
  const sm4 = new JSSM4('8c82deb5c3fb4a3d')
  return sm4.encryptData_ECB(text)
}

// sm4解密
function sm4Decrypt(text) {
  const sm4 = new JSSM4('8c82deb5c3fb4a3d')
  return sm4.decryptData_ECB(text)
}

// sm2加密
function sm2Encrypt(text, key) {
  key =
    key ||
    '0441b12d4f059691e1888ebda5b08dc4d11e9e92ec6cc66ba7a89f9c46e4c1a736aca65d6cca2657ae6857d7f39299ae2b7bc1c632316574fab7f0eed52a9f4bac'
  const enText = sm2.doEncrypt(text, key, cipherMode)
  return `04${enText}`
}

// sm2解密
function sm2Decrypt(text, key) {
  key = key || '2f6e9917ceca0da9e99a0156d96bca8c2289a98004d7e8b0f7e6e0d04e44a05f'
  if (text) {
    const deText = sm2.doDecrypt(text.slice(2), key, cipherMode)
    return deText
  }
  return ''
}

// 模块分别导出
module.exports = {
  sm4Encrypt,
  sm4Decrypt,
  sm2Encrypt,
  sm2Decrypt
}
